export default __webpack_public_path__ + "static/media/chart.b0b3b8cd.svg";